import React from 'react';
import clsx from 'clsx';

import { Radio } from '../../../components';
import { useLocalize } from '../../../hooks';
import { MarkdownContainer } from '../../../components';
import type { QuizQuestionType } from '../../../api';

type QuestionOptionProps = {
  option: string;
  answer?: string;
  question?: QuizQuestionType;

  handleAnswerQuestion: (questionId: string, answer: string) => void;
};

type QuizQuestionProps = {
  answer?: string;
  isMobile?: boolean;
  questionIndex: number;
  question?: QuizQuestionType;

  handleAnswerQuestion: (questionId: string, answer: string) => void;
};

const QuestionOption: React.FC<QuestionOptionProps> = ({
  answer,
  option,
  question,
  handleAnswerQuestion,
}) => {
  // const answerUndefined = typeof question?.correct === 'undefined';
  const answerUndefined = false;
  const answerCorrect = false;

  return (
    <div
      onClick={() =>
        question && handleAnswerQuestion(question.questionId!, option)
      }
      className={clsx(
        'mb-sm p-md border border-accordionBorder rounded-bt hover:border-main hover:cursor-pointer',
        answerUndefined &&
          (answerCorrect
            ? 'bg-correctBack border-completed hover:border-completed'
            : 'bg-nonCorrectBack border-nonCorrect hover:border-nonCorrect')
      )}
    >
      {/* {true && ( */}
      {answerUndefined && (
        <div className="mb-sm">
          <span
            className={clsx(
              'px-sm py-xs border-transparent rounded-xs text-tiny text-white font-semibold',
              answerCorrect ? 'bg-completed' : 'bg-nonCorrect'
            )}
          >
            {answerCorrect
              ? 'Your answer is correct'
              : 'Your answer is incorrect'}
          </span>
        </div>
      )}
      <Radio
        name="question"
        label={option}
        value={option === answer}
        containerClassName="mr-sm"
        labelClassName="text-medium font-bold"
      />
    </div>
  );
};

export const QuizQuestion: React.FC<QuizQuestionProps> = ({
  answer,
  question,
  isMobile,
  questionIndex,
  handleAnswerQuestion,
}) => {
  const { t } = useLocalize();

  if (!question) return;

  const content = `
  **${t('quiz.page.question')} ${questionIndex + 1}**

  ${question?.questionText}
  `;

  return (
    <div className="text-medium">
      <div className="mb-lg">
        <MarkdownContainer className="text-medium">{content}</MarkdownContainer>
      </div>

      <div
        style={{ maxHeight: isMobile ? 'calc(100dvh - 48rem)' : undefined }}
        className={isMobile ? 'overflow-y-auto' : ''}
      >
        {question.options?.map(option => {
          return (
            <QuestionOption
              key={option}
              answer={answer}
              option={option}
              question={question}
              handleAnswerQuestion={handleAnswerQuestion}
            />
          );
        })}
      </div>
    </div>
  );
};
